import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { SidebarLayout, Footer, Header, Icon, toggleTheme, ThemeType } from '@scuf/common'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../../actions/authLogin'


import './Layout.css'
//import '@scuf/common/honeywell-compact-dark/theme.css'
//import "@scuf/common/honeywell-dark/theme.css";
//import KPI from '../KPI/KPI'
//import "@scuf/datatable/honeywell-combined/theme.css";

const Layout = (props) => {

    const dispatch = useDispatch()
    const stateRedux = useSelector(state => state)
    const [state, setState] = useState({
        user: JSON.parse(localStorage.getItem('user')),
        sidebarCollapsed: true,
        logoCompany: '../../assets/Codelco_logo.png',
        isDark: true
    })


    // // inicial state redux
    useEffect(() => {
        if (Object.keys(stateRedux.login).length === 0) {
            dispatch(login(JSON.parse(localStorage.getItem('user'))))
        }



    }, [dispatch, stateRedux.login])

    useEffect(() => {
        toggleTheme(ThemeType.Dark);
        // toggleTheme(ThemeType.Light);
    }, []
    )

    // const onCollapsedClick = () => {
    //     setState({ ...state, sidebarCollapsed: !state.sidebarCollapsed })
    // }

    // const onSettingsCollapsedClick = () => {
    //     setState({ ...state, settingsCollapsed: !state.settingsCollapsed })
    // }


    // const changeLogo = (dark) => {
    //     if(dark){
    //       toggleTheme(ThemeType.Dark);
    //       setState({
    //         ...state,
    //         logoCompany: '../../assets/hydro-white.jpg',
    //         isDark: dark
    //       })
    //     }else{
    //       if(dark){
    //         toggleTheme(ThemeType.Light);
    //         setState({
    //             ...state,
    //             logoCompany: '../../assets/hydro-black.jpg',
    //             isDark: dark
    //         })
    //       }
    //     }
    // }

    const tituloHeader = (titulo) => {
        localStorage.setItem('tituloHeader', titulo);
        return titulo
    }

    const changeLogoDark = () => {

        if (state.isDark) {
            toggleTheme(ThemeType.Dark);
            setState({
                ...state,
                logoCompany: '../../assets/Codelco_logo.png',
                isDark: false
            })
        } else {
            toggleTheme(ThemeType.Light);
            setState({
                ...state,
                logoCompany: '../../assets/Codelco_logo.png',
                isDark: true
            })
        }

        localStorage.setItem('isDark', state.isDark)
    }

    // const validate = () => {
    //     // const emailValidationRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //     return {
    //       // email: emailValidationRegex.test(this.state.email.trim()) ? null : 'Invalid Email',
    //       name: this.state.name.trim() ? null : 'Required',
    //       message: this.state.message.trim() ? null : 'Required'
    //     }
    // }

    // const listTop = () => {
    //     var list = [];
    //     return list;
    // }

    const ItemMenuHorizontalAPC = (title) => {
        return <div className='item-menu'>
            <span style={{ marginLeft: '-6px', fontWeight: '700' }}>APC</span>
            <div style={{ textAlign: 'center' }}>{title}</div>
        </div>
    }

    const ItemMenuHorizontal = (title, icon) => {
        return <div className='item-menu'>
            <Icon root='common' name={icon} exactSize={22}></Icon>
            <div style={{ textAlign: 'center' }}>{title}</div>
        </div>
    }

    const iconText = ({ text, icon }) => {
        return <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            {icon}
            <div className='label-menu'>{text}</div>
        </div>;
    }

    return (
        <>
            <Header menu={false} logo={true} logoUrl='./honeywell-logo.svg' isForge={false} title={localStorage.getItem('tituloHeader')} onMenuToggle={() => setState({ ...state, sidebarCollapsed: !state.sidebarCollapsed })} >
                {/* <Header.Item style={{ padding: '0px' }}>
                    <div
                        onClick={x => changeLogoDark()}
                        style={{
                            width: '30px',
                            marginRight: '10px',
                            marginLeft: '10px',
                            borderRadius: '5px',
                            height: '30px',
                            backgroundImage: 'url(../../assets/Codelco_logo.png)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain'
                        }}>
                    </div>
                </Header.Item> */}
                {/* <Header.AppLauncher>
                    <Header.AppLauncher.Item appName={<Link to="/apc">
                        <SidebarLayout.Sidebar.Item onClick={() => setState({ ...state, titulo: "APC" })}
                            icon={
                                iconText({
                                    text: 'APC',
                                    icon: <span style={{ marginLeft: '-6px', fontWeight: '600' }}>APC</span>
                                })}
                        />
                    </Link>} />

                    <Header.AppLauncher.Item appName={<Link to="/procesos">
                        <SidebarLayout.Sidebar.Item onClick={() => setState({ ...state, titulo: "PROCESOS" })}
                            icon={
                                iconText({
                                    text: 'Procesos',
                                    icon: <Icon root='common' name='increasing'></Icon>
                                })}
                        />
                    </Link>} />
                </Header.AppLauncher> */}



                <Header.UserProfile firstName={'-'} >
                    <Header.UserProfile.Item>
                        <div className='menu-header' style={{ width: "110px" }}>Seleccionar</div>
                    </Header.UserProfile.Item>
                    <Header.UserProfile.Item>
                        <Link className='item-menu-link' to="/apc" onClick={() => localStorage.setItem('tituloHeader', "APC")}>
                            <div className='menu-header' >APC</div>
                        </Link>
                    </Header.UserProfile.Item>
                    <Header.UserProfile.Item>
                        <Link className='item-menu-link' to="/Infraestructura" onClick={() => localStorage.setItem('tituloHeader', "INFRAESTRUCTURA")}>
                            <div className='menu-header'>Infraestructura</div>
                        </Link>
                    </Header.UserProfile.Item>
                    <Header.UserProfile.Item>
                        <Link className='item-menu-link' to="/procesos" onClick={() => localStorage.setItem('tituloHeader', "PROCESOS")}>
                            <div className='menu-header'>Procesos</div>
                        </Link>
                    </Header.UserProfile.Item>

                    <Header.UserProfile.Item>
                        <Link className='item-menu-link' to="/diario" onClick={() => localStorage.setItem('tituloHeader', "DIARIO")}>
                            <div className='menu-header'>Diario</div>
                        </Link>
                    </Header.UserProfile.Item>

                    <Header.UserProfile.Item>
                        <Link className='item-menu-link' to="/login" >
                            <div className='menu-header'>Log Out</div>
                        </Link>
                    </Header.UserProfile.Item>
                </Header.UserProfile>

            </Header>


            <SidebarLayout noIcons={state.sidebarCollapsed} collapsed={true} className="example-sidebar">
                <SidebarLayout.Sidebar>

                    <Link to="/apc">
                        <SidebarLayout.Sidebar.Item content="Detail" onClick={() => setState({ ...state, titulo: "APC" })}
                            icon={
                                iconText({
                                    text: 'APC',
                                    icon: <span style={{ marginLeft: '-6px', fontWeight: '600' }}>APC</span>
                                })}
                        />
                    </Link>

                    <Link to="/kpi">
                        <SidebarLayout.Sidebar.Item onClick={() => setState({ ...state, titulo: "KPI" })}
                            content="Detail"
                            icon={
                                iconText({
                                    text: 'KPI',
                                    icon: <Icon root='common' name='CMX'></Icon>
                                })}
                        />
                    </Link>

                    <Link to="/procesos">
                        <SidebarLayout.Sidebar.Item onClick={() => setState({ ...state, titulo: "PROCESOS" })}
                            content="Overview"
                            icon={
                                iconText({
                                    text: 'Procesos',
                                    icon: <Icon root='common' name='increasing'></Icon>
                                })}
                        />
                    </Link>


                </SidebarLayout.Sidebar>
                <SidebarLayout.Content>
                    <div style={{ width: '100%', marginBottom: '0px' }} className='m-0 p-0'>
                        {props.component}
                    </div>
                </SidebarLayout.Content>
            </SidebarLayout>

            {/* <Footer className='mt-0 mb-0'>
                <Footer.Item href="#">Terms & Conditions</Footer.Item>
                <Footer.Item href="#">Privacy Policy</Footer.Item>
            </Footer> */}
        </>
    )
}

export default Layout
